import React from 'react';
import nutricionistaImage from '../../assets/images/servicos/nutricionista.jpg';

const Nutricionista = () => {
    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>Nutricionista Infantil</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">Nutricionista Infantil</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="with-sidebar">
                        <article className="blog-entry">
                            <div className="blog-entry-inner">
                                <div className="entry-thumb">
                                    <img src={nutricionistaImage} alt="Nutricionista Infantil" />
                                </div>
                                <div className="entry-details">
                                    <div className="entry-title">
                                        <h3> Nutrição Infantil </h3>
                                    </div><br />
                                    <div className="entry-body">
                                        <p>O nutricionista infantil é um profissional que ajudará as famílias a ajustarem hábitos alimentares e a melhorarem as suas práticas.</p><br />
                                        <p>Visando garantir o crescimento e desenvolvimento adequado das crianças.</p><br />
                                        <p>A nutricionista também ajudará em uma dieta balanceada, na introdução de alimentos sólidos, na educação alimentar.</p><br />
                                        <p>A nutricionista desenvolverá uma orientação específica para cada paciente, garantindo que as necessidades individuais da criança sejam atendidas.</p><br />
                                        <p><b>Lembre-se de que uma alimentação saudável durante a infância estabelece a base para um crescimento saudável e um futuro promissor.</b></p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section id="secondary">
                        <aside className="widget widget_text">
                            <h3 className="widgettitle">Nossos serviços incluem</h3>
                            <p>Planejamento alimentar individualizado, introdução alimentar e educação nutricional para pais e filhos.</p><br />
                        </aside>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Nutricionista;
